export default __webpack_public_path__ + "static/media/KZ.Т.12.2505 black.bda8e956.svg";